import { lruMemoize } from '@reduxjs/toolkit';
import { at, isNil } from 'lodash-es';

import type { Entities } from '@iconik-io/shared-lib/src/redux/entities/types';

export const createListItemsSelector = <T>() =>
  lruMemoize((entities: Entities<T>, ids: string[]) => {
    const items = at(entities, ids);
    return items.filter((item) => !isNil(item));
  });
